import { display } from './display';
var onMonitorErrorCollected;
var debugMode = false;
export function startMonitorErrorCollection(newOnMonitorErrorCollected) {
  onMonitorErrorCollected = newOnMonitorErrorCollected;
}
export function setDebugMode(newDebugMode) {
  debugMode = newDebugMode;
}
export function resetMonitor() {
  onMonitorErrorCollected = undefined;
  debugMode = false;
}
export function monitored(_, __, descriptor) {
  var originalMethod = descriptor.value;
  descriptor.value = function () {
    var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return decorated.apply(this, args);
  };
}
export function monitor(fn) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return callMonitored(fn, this, args);
  }; // consider output type has input type
}
export function callMonitored(fn, context, args) {
  try {
    return fn.apply(context, args);
  } catch (e) {
    monitorError(e);
  }
}
export function monitorError(e) {
  displayIfDebugEnabled(e);
  if (onMonitorErrorCollected) {
    try {
      onMonitorErrorCollected(e);
    } catch (e) {
      displayIfDebugEnabled(e);
    }
  }
}
export function displayIfDebugEnabled() {
  if (debugMode) {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    display.error.apply(display, ['[MONITOR]'].concat(args));
  }
}